import { MrCarousel } from '@mrhenry/wp--mr-interactive';

class MrCarouselFormatted extends MrCarousel {
	override get value() {
		return super.value.split( '/' ).join( ' — ' );
	}
}

customElements.define( 'mr-carousel-formatted', MrCarouselFormatted );
